import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import images from '@src/style/images';

export const VpHeaderLogo = () => {
  return (
    <Link to="/campaign">
      <Box sx={{ height: '30px' }} component="img" src={images.logoinner} />
    </Link>
  );
};

export default VpHeaderLogo;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpHeaderLogo/VpHeaderLogo.jsx